
import './App.scss';
import icon1 from './img/icon1.png'
import icon5 from './img/icon5.png'
import share from './img/share.png'
import share2 from './img/share2.png'
import { useEffect, useState } from 'react';
import SwiperComponent from './Swiper'
import { HashRouter, BrowserRouter, Routes, Route, NavLink, useLocation } from 'react-router-dom'
import CalendarItem from './components/CalendarItem'
import AllCalendar from './components/AllCalendar';
import Newcalendar from './components/NewCalendar'
import AppApi from './utils/bridge.js'
const Test = () => {
  return <div>hello test</div>
}

function App() {
  const location = useLocation()
  let u = navigator.userAgent;
  console.log(u)

  const routerName = () => {
    console.log(location)
    return location.pathname
  };

  const [topClass, setTopClass] = useState('g-top')
  const [appClass, setAppClass] = useState('g-app')
  const [isMethodMounted, setIsMethodMounted] = useState(false);
  // 检测目标方法是否挂载
  useEffect(() => {
    if (u.includes('nbd')) {
      const interval = setInterval(() => {
        if (window.WebViewJavascriptBridge.callHandler && typeof (window.WebViewJavascriptBridge.callHandler) == "function") {
          setIsMethodMounted(true);
          clearInterval(interval);
        }
      }, 100); // 每隔 500ms 检查一次
      return () => clearInterval(interval);
    }

  }, []);

  useEffect(() => {
    AppApi.title_control({
      hide_action_bar: true,
      hide_more: true
    })
    if (u.split('nbdapp_v7 v_')[2] >= '7.3.0') {

      setTopClass('g-top u-no-top')
      setAppClass('g-app')
    } else if (!u.includes('nbd')) {

      setTopClass('g-top hidden')
      setAppClass('g-app no-padding')
    } else {

      setTopClass('g-top')
      setAppClass('g-app')
    }
  })




  const [isApp, setIsApp] = useState(u.split('nbdapp_v7 v_')[2] < '7.3.0');
  const [path, setPath] = useState(() => routerName());
  useEffect(() => {
    setPath(location.pathname)
  })
  const Nav = (props) => {
    return (
      <div className={topClass}>
        <img src={icon5} className="u-icon1" onClick={back} />
        财经日历

        <img src={share2} className="u-share" onClick={shareInfo} />
      </div>
    )
  }


  const back = () => {
    if (path == '/') {
      AppApi.pop()
    } else {
      window.history.go(-1)
    }
  }


  const shareInfo = () => {
    let year = new Date().getFullYear()
    let mon = new Date().getMonth() + 1
    let day = new Date().getDate()
    // console.log(year + '年' + mon + '月' + day + '日' + ' 每经日历')
    AppApi.share({
      share_digest: '收藏！一览2023年财经大事件，抢先了解全球重磅资讯',
      share_image: "http://static.nbd.com.cn/images/app/nbd_icon_300_normal.png",
      share_title: year + '年' + mon + '月' + day + '日' + ' 每经日历',
      share_url: 'https://www.nbd.com.cn/corp/NBDCalendar/build/index.html'
    })
  }
  if (!isMethodMounted && u.includes('nbd')) {
    return <div></div> // 阻塞界面
  }
  return (

    <div className={appClass}>
      <Nav />
      <Routes>
        <Route path="/" element={<Newcalendar />}></Route>
      </Routes>

    </div>


  )


}

export default App;
